var a: HTMLAnchorElement;

export default function getAbsoluteUrl(url: string) {
  if (!a) a = document.createElement('a');
  a.href = url;

  return a.href;
}
